import React, { lazy } from "react";

const LazyApttusExceptions = lazy(() => import("./ApttusExceptions"));

const ApttusExceptions = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyApttusExceptions {...props} />;

export default ApttusExceptions;
